<template>
    <div class="not-found">
        <Header class="header"/>
        <div>
            <img class="img-404" src="@/assets/404.png" alt="">
        </div>
        <Footer class="footer"/>
    </div>
</template>

<script>
import Header from './Header/Header'
import Footer from './Footer/Footer'

export default {
    name: 'NotFound',
    components: {
        Header,
        Footer
    }
}
</script>

<style>
    .not-found > .header {
        height: 100%;
    }
    .not-found > div {
        position: relative;
        width: 100%;
        height: 60vh;
    }
    .not-found > div > img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        height: auto;
    }
    .not-found > .footer {
        height: 100%;
    }
    @media (max-width: 530px) {
        .not-found > div > img {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue